import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  button: {
    minWidth: '96px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  badge: {
    top: '8px',
    right: '8px',
    minWidth: '20px',
    height: '20px',
    borderRadius: '10px',
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: '0 6px',
  },
}));
